<script type="text/babel">
import NavigationProvider from 'dashboard-js/providers/NavigationProvider'
import PreventClickFocus from 'dashboard-js/directives/PreventClickFocus'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    directives: { PreventClickFocus },

    mixins: [RestoreOnPageBack],

    props: ['dataPlatforms'],

    data() {
        return {
            platforms: this.dataPlatforms,
            form: new SparkForm({
                name: null,
                platform_id: '',
            }),
        }
    },

    computed: {
        // instagramPlatformId() {
        //     return this.platforms.filter(platform => platform.slug === 'instagram')[0].id
        // },

        instagramBusinessPlatformId() {
            return this.platforms.filter(platform => platform.slug === 'instagram_business')[0].id
        },

        // instagramBusinessSelected: {
        //     get: function() {
        //         return this.form.platform_id === this.instagramBusinessPlatformId
        //     },
        //     set: function(selected) {
        //         const id = selected ? this.instagramBusinessPlatformId : this.instagramPlatformId
        //
        //         this.$set(this.form, 'platform_id', id)
        //     },
        // },
        //
        // anyInstagramSelected() {
        //     return (
        //         this.form.platform_id === this.instagramPlatformId ||
        //         this.form.platform_id === this.instagramBusinessPlatformId
        //     )
        // },

        // selectedPlatformId: {
        //     get: function() {
        //         return this.anyInstagramSelected ? this.instagramPlatformId : this.form.platform_id
        //     },
        //     set: function(id) {
        //         this.form.platform_id = id
        //     },
        // },

        // visiblePlatforms() {
        //     return this.platforms.filter(
        //         platform => platform.id !== this.instagramBusinessPlatformId
        //     )
        // },
    },

    methods: {
        create() {
            Spark.post(route('api.campaign.store'), this.form).then(response => {
                NavigationProvider.go(`/campaigns/${response.data.id}/edit`)
            })
        },
    },
}
</script>
